import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-light d-none d-md-flex z-index-fix fixed-top",
  id: "topbar"
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "navbar-user" }
const _hoisted_5 = { class: "dropdown" }
const _hoisted_6 = {
  href: "#",
  class: "avatar avatar-sm dropdown-toggle d-flex align-items-center w-fix",
  role: "button",
  "data-bs-toggle": "dropdown",
  "aria-haspopup": "true",
  "aria-expanded": "false"
}
const _hoisted_7 = { class: "dropdown-menu dropdown-menu-end" }

import { useMainStore } from "@/infra/store";
import { computed } from "vue";
import { routes } from "@/presentation/router";
import AccountImage from "./AccountImage.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Navbar',
  setup(__props) {

const session = computed(() => useMainStore().session);

return (_ctx: any,_cache: any) => {
  const _component_Logo = _resolveComponent("Logo")!
  const _component_Typograph = _resolveComponent("Typograph")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, { to: "/home/geral" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Logo, { type: "square" }),
            _createVNode(_component_Typograph, {
              variant: "pagesubtitle",
              class: "mx-2 mt-2 text-dark"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(session.value?.partnership?.name || "GreeZon"), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", _hoisted_6, [
            _createVNode(_component_Typograph, {
              variant: "subtitle",
              class: "text-dark me-2"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(session.value?.name), 1)
              ]),
              _: 1
            }),
            (session.value)
              ? (_openBlock(), _createBlock(AccountImage, {
                  key: 0,
                  userSession: session.value
                }, null, 8, ["userSession"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: {
                name: _unref(routes).admins.detail?.name,
                params: { id: session.value?.id },
              },
              class: "dropdown-item"
            }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createTextVNode("Minha conta")
              ])),
              _: 1
            }, 8, ["to"]),
            _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)),
            _createVNode(_component_router_link, {
              to: _unref(routes).login.path,
              class: "dropdown-item text-danger"
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("Sair")
              ])),
              _: 1
            }, 8, ["to"])
          ])
        ])
      ])
    ])
  ]))
}
}

})